import { useGetLlmPronunciationSuggestionsMutation } from '@replacements/graphql/smartReplacements/operation.generated';

export interface LlmContext {
  script: string;
  wordStartIndex: number;
  wordEndIndex: number;
}

const useLlmPronunciationsQuery = ({
  word,
  context,
}: {
  word: string;
  context?: LlmContext | undefined;
}) => {
  return useGetLlmPronunciationSuggestionsMutation({
    variables: { inputs: { word, context } },
  });
};

export default useLlmPronunciationsQuery;
